module.exports = __webpack_public_path__ + "static/media/CenturyGothicBold.27279b93.svg";